<template>
  <a-spin :indicator="customIndicator" />
</template>

<script>
import { h, computed } from "vue";
import { LoadingOutlined } from "@ant-design/icons-vue";
import mainTheme from "@/assets/themes/mainTheme";

export default {
  name: "ClipLoaderVue",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "white",
    },
    size: {
      type: [String, Number],
      default: 30,
    },
  },
  data() {
    return {
      theme: mainTheme,
    };
  },
  computed: {
    customIndicator() {
      // re-computed automatically when color or size changes
      return h(LoadingOutlined, {
        style: {
          fontSize: `${this.size}px`,
          color: this.themeColors(),
        },
        spin: true,
      });
    },
  },
  methods: {
    themeColors() {
      const theme = this.theme;
      const splitClass = this.color?.trim().split("-");
      const primary = splitClass?.[0];
      const secondary = splitClass?.[1];

      if (!primary) return "white";

      if (secondary) {
        return theme?.[primary]?.[secondary] ?? "white";
      } else {
        return primary;
      }
    },
  },
};
</script>

<style scoped></style>
